import styled from 'styled-components';

export const MapRouteAnchor = styled.a`
  display: flex;
  align-items: center;

  svg {
    margin-right: 0.18rem;
  }
`;
